import actions from './actions.js';
import { TRIP_STATE } from '../../mutation-types';
import moment from 'moment';

const initialState = {
    actualTrip: null,
    actualTripMetadata: null,
    tripsHistory: [],
    isAvailable: false,
    offeredTrips: [],
    alreadyPlayedNotifications: {
        driverCanceled: {},
        driverOfrecido: {}
    },
    alreadyViewedTrips: {},
    missedTrips: [],
    canceledTrip: null,
    qrPaymentNotified: {} // Track QR payment notifications by trip ID
};

const state = Object.assign({}, initialState);

const getters = {
    actualTrip: state => state.actualTrip,
    actualTripMetadata: state => state.actualTripMetadata,
    tripsHistory: state => state.tripsHistory,
    isWaitingRequest: state => state.actualTrip && state.actualTrip.frontState === TRIP_STATE.PENDING,
    isAccepted: state => state.actualTrip && state.actualTrip.chofer,
    isRideUp: state => state.actualTrip && state.actualTrip.pasajeroAbordo,
    isDriverNear: state => state.actualTrip && state.actualTrip.llegando,
    isAvailable: state => state.isAvailable,
    offeredTrips: state => state.offeredTrips,
    passengerPosition: state => state.actualTrip ? { lat: state.actualTrip.lat, lng: state.actualTrip.lng } : null,
    passengerOffered: state => state.offeredTrips && state.offeredTrips.length > 0 ? { lat: state.offeredTrips[0].lat, lng: state.offeredTrips[0].lng } : null,
    alreadyPlayedNotifications: state => state.alreadyPlayedNotifications,
    alreadyViewedTrips: state => state.alreadyViewedTrips,
    missedTrips: state => state.missedTrips,
    canceledTrip: state => state.canceledTrip
};

const mutations = {
    RESET_STATES (state) {
        Object.assign(state, initialState);
    },

    CHANGE_AVAILABILITY (state, availability) {
        state.isAvailable = availability;
    },

    SET_ACTUAL_TRIP (state, trip) {
        state.actualTrip = trip;
    },

    SET_ACTUAL_TRIP_METADATA (state, metadata) {
        state.actualTripMetadata = metadata;
    },

    SET_HISTORY_TRIP (state, trips) {
        state.tripsHistory = trips;
    },

    ADD_OFFERED_TRIPS (state, trips) {
        if (!state.offeredTrips) {
            state.offeredTrips = [];
        }
        state.offeredTrips.push(trips);
    },

    SET_OFFERED_TRIPS (state, trips) {
        state.offeredTrips = trips;
    },

    POP_OFFERED_TRIPS (state) {
        state.offeredTrips.pop();
    },

    SET_VIEWED_OFFERED_TRIP (state, id) {
        state.alreadyViewedTrips[id] = true;
    },

    SET_MISSED_TRIPS (state, trips) {
        let localMissingTrips = [];
        try {
            let json = window.localStorage.getItem('missed_trip');
            if (!json) {
                json = '[]';
            }
            localMissingTrips = JSON.parse(json);
            for (let index = localMissingTrips.length - 1; index >= 0; index--) {
                const localTrip = localMissingTrips[index];
                if (moment(localTrip.date).isBefore(moment().startOf('day'))) {
                    // si es anterior lo quito
                    localMissingTrips.splice(index, 1);
                }
            }
            // mantengo actualizado el localStorage
            window.localStorage.setItem('missed_trip', JSON.stringify(localMissingTrips));
        } catch (ex) {
            console.log('read storage missed trip', ex);
        }
        if (trips && trips.length) {
            for (let index = trips.length - 1; index >= 0; index--) {
                let newTrip = trips[index];
                if (newTrip && newTrip.id) {
                    if (state.missedTrips && state.missedTrips.length) {
                        let trip = state.missedTrips.find(item => (item && item.id === newTrip.id));
                        if (trip) {
                            trips.splice(index, 1);
                        }
                    }
                    if (localMissingTrips && localMissingTrips.length) {
                        let lTrip = localMissingTrips.find(item => (item && item.viaje_id === newTrip.id));
                        if (lTrip) {
                            trips.splice(index, 1);
                        }
                    }
                }
            }
        }
        state.missedTrips = trips;
    },

    MARK_AS_ALERTED_MISSING (state, t) {
        if (state.missedTrips && state.missedTrips.length) {
            let trip = state.missedTrips.find(item => item.id === t.id);
            if (!trip) {
                console.log('mark as alerted');
                trip.alertedMissing = true;
            }
        }
    },

    REMOVE_MISSED_TRIPS (state, trip) {
    },

    ADD_HISTORY_TRIP (state, trip) {
        state.tripsHistory.push(trip);
    },

    REMOVE_HISTORY_TRIP (state, trip) {
        let index = state.tripsHistory.findIndex(item => item.id === trip.id);
        if (index >= 0) {
            state.tripsHistory.splice(index, 1);
        }
    },

    SET_PLAYED_NOTIFICATONS (state, action, tripId) {
        if (action && tripId) {
            state.alreadyPlayedNotifications[action][tripId] = true;
        }
        state.alreadyPlayedNotifications[action][tripId] = true;
    },

    SET_CANCELED_TRIP (state, trip) {
        state.canceledTrip = trip;
    },

    MARK_QR_PAYMENT_NOTIFIED (state, tripId) {
        state.qrPaymentNotified[tripId] = true;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/driver/driver.js